const newInterval = setInterval(() => {}, 10000);

for (let i = 0; i <= newInterval; i += 1) {
  clearInterval(i);
}



// WEBPACK FOOTER //
// ./src/lib/clearAllIntervals.js